import {Link} from "react-router-dom";

const Hero = () => {
    return (
        <div
            id="top"
            className="relative w-full
            portrait:h-[85dvh] portrait:sm:h-[58.5dvh] portrait:md:h-[67.5dvh]
            landscape:aspect-video landscape:max-h-[85dvh]"
        >
            <div className="relative h-full w-full">
                <img
                    src="/assets/home-page-hero-section-bg.png"
                    alt=""
                    className="absolute w-full h-full object-bottom object-cover shadow-lg"
                />
                <div
                    className="absolute h-full w-full flex items-end
                    landscape:px-[2rem] landscape:md:px-[4rem]"
                >
                    <img
                        src="/assets/hero-section-home-page-banner-statue.png"
                        alt=""
                        className="portrait:w-[30%] portrait:md:w-[25%]
                        landscape:h-[70%] aspect-auto object-contain"
                    />
                    <img
                        src="/assets/hero-section-home-page-title.svg"
                        alt=""
                        className="portrait:w-[60%] portrait:md:w-[45%]
                        landscape:h-[50%] aspect-auto object-contain
                        portrait:mb-[1.25rem] portrait:sm:mb-[2rem]
                        landscape:mb-[1.25rem] landscape:md:mb-[2rem]"
                    />
                </div>
            </div>

            {/*
                portrait:h-[2.5rem] portrait:p-[0.4rem] portrait:pl-[0.65rem]
                portrait:sm:h-[4rem] portrait:sm:p-[0.65rem] portrait:sm:pl-[1.5rem]
                portrait:jk:h-[3.5rem] portrait:jk:p-[0.5rem]
            */}

            {/* Circle images */}
            <div
                className="absolute top-0 h-full portrait:right-[0.75rem] landscape:right-[0.5rem]
                flex flex-col items-end gap-y-[2rem]
                portrait:pt-[4rem] portrait:sm:pt-[6rem] portrait:jk:pt-[5.25rem]
                landscape:pt-[3.5rem] landscape:jk:pt-[4.5rem]
                pb-[4vw]"
            >
                <div className="flex flex-row portrait:gap-[2dvh] landscape:gap-[4dvh]">
                    {/* landscape:h-[6rem] landscape:md:h-[8rem] landscape:jk:h-[10rem] */}
                    {[
                        {
                            src: "/kulvratant_landingPage/circle image-shivapind.png",
                            alt: "Vyadeshwar, Guhagar",
                            text: "व्याडेश्वर, गुहागर",
                            url: '/vyadeshwar'
                        },
                        {
                            src: "/kulvratant_landingPage/circle image-kuldevi.png",
                            alt: "Yogeshwari Devi, Ambajogai",
                            text: "योगेश्वरी देवी, अंबाजोगाई",
                            url: '/ambajogai'
                        },
                    ].map((img, index) => (
                        <Link to={img.url}>
                            <div key={index} className="flex flex-col items-center justify-center">
                                <img
                                    src={img.src}
                                    alt={img.alt}
                                    className="portrait:h-[8rem] portrait:jk:h-[12rem]
                                    landscape:h-[22.5dvh]
                                    aspect-square rounded-full border-4 border-white object-cover"
                                />
                                {/* landscape:text-[0.75rem] landscape:jk:text-[0.9rem] */}
                                <p
                                    className="text-white mt-1 font-custom-semi-bold text-center
                                    portrait:text-[0.8rem] portrait:sm:text-[1rem] portrait:jk:text-[1.25rem]
                                    landscape:text-[2.25dvh]"
                                >
                                    {img.text}
                                </p>
                            </div>
                        </Link>
                    ))}
                </div>

                <div
                    className="flex items-center justify-between gap-x-[1rem]"
                >
                    <div
                        className="hidden h-full landscape:sm:flex portrait:flex flex-col justify-between"
                    >
                        {[
                            {
                                src: "/other_imgs/thumbnail-aarti.jpg",
                                alt: "aarti",
                                text: "आरती",
                                url: '/aarti'
                            },
                            {
                                src: "/other_imgs/thumbnail-mantropchar.jpg",
                                alt: "mantropchar",
                                text: "मंत्रोप्चार",
                                url: '/mantropchar'
                            },
                        ].map((img, index) => (
                            <div key={index} className="flex flex-col items-center justify-center">
                                <Link to={img.url}>
                                    {/* landscape:w-[3rem] landscape:sm:w-[4rem] landscape:jk:w-[5rem] */}
                                    <img
                                        src={img.src}
                                        alt={img.alt}
                                        className="landscape:h-[9dvh]
                                            portrait:w-[3.5rem] portrait:sm:w-[4rem] portrait:jk:w-[5rem]
                                            rounded-full border-2 border-white object-cover"
                                    />
                                    <p
                                        className="text-white mt-1 font-custom-semi-bold text-center landscape:text-[1.5dvh]
                                            portrait:text-[0.8rem] portrait:sm:text-[1rem] portrait:jk:text-[1.25rem]"
                                    >
                                        {img.text}
                                    </p>
                                </Link>
                            </div>
                        ))}
                    </div>
                    <div className="flex flex-col items-center justify-center">
                        <a
                            href="https://jogkulstorageuat.blob.core.windows.net/siteassets/myFolder/joglekar_kulvrutant_2010.pdf "
                            target="_blank"
                            rel="noreferrer"
                        >
                            {/* landscape:h-[6rem] landscape:sm:h-[11rem] landscape:jk:h-[14rem] */}
                            <img
                                src="/other_imgs/granth_joglekar_kulvrutant.jpg"
                                alt="2010 - ग्रंथ"
                                className="landscape:h-[22.5dvh]
                                    portrait:h-[9rem] portrait:sm:h-[11rem] portrait:jk:h-[14rem]
                                    border-2 border-white object-cover"
                            />
                        </a>
                        <p
                            className="font-custom-semi-bold text-white mt-1 text-center landscape:text-[1.75dvh]
                                portrait:text-[0.8rem] portrait:sm:text-[1rem] portrait:jk:text-[1.25rem]"
                        >
                            2010 - ग्रंथ
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
